// extracted by mini-css-extract-plugin
export default {"canvas":"Description_canvas__QOCmF","section_section1_main":"Description_section_section1_main__hqBt5","section_section1_cards":"Description_section_section1_cards__dzb0Z"};